import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const Panel = ({ title, desc, children, testid }) => (
  <section className="bg-white border border-border rounded-lg p-6 sm:p-8 mb-6" data-testid={testid}>
    <h2 className="text-2xl">{title}</h2>
    {desc && <p className="text-sm text-muted-foreground mt-1">{desc}</p>}
    <div className="mt-6">{children}</div>
  </section>
);

export const TextField = ({ label, value, onChange, type = "text", testid, area, rows = 3 }) => (
  <div className="space-y-1.5">
    <Label htmlFor={testid}>{label}</Label>
    {area ? <Textarea id={testid} rows={rows} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
      : <Input id={testid} type={type} value={value} onChange={(e) => onChange(type === "number" ? e.target.value : e.target.value)} data-testid={testid} />}
  </div>
);

// Editable list of objects with given string/number fields.
export const RowsEditor = ({ rows, setRows, fields, blank, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    {rows.map((r, i) => (
      <div key={i} className="flex gap-2 items-start">
        {fields.map(([k, ph, type]) => (
          <Input key={k} placeholder={ph} type={type || "text"} value={r[k]} className={type === "number" ? "w-28" : "flex-1"}
            onChange={(e) => setRows(rows.map((x, j) => (j === i ? { ...x, [k]: e.target.value } : x)))} data-testid={`${testid}-${i}-${k}`} />
        ))}
        <button type="button" onClick={() => setRows(rows.filter((_, j) => j !== i))} aria-label="Remove" className="p-2 text-muted-foreground hover:text-destructive" data-testid={`${testid}-${i}-remove`}><Trash2 className="w-4 h-4" /></button>
      </div>
    ))}
    <button type="button" onClick={() => setRows([...rows, { ...blank }])} className="text-sm flex items-center gap-1 text-[hsl(var(--sage))]" data-testid={`${testid}-add`}><Plus className="w-4 h-4" /> Add</button>
  </div>
);

export const SaveButton = ({ onClick, busy, testid, label = "Save changes" }) => (
  <button type="button" onClick={onClick} disabled={busy} className="bg-primary text-primary-foreground px-6 py-2.5 rounded-full text-sm font-semibold disabled:opacity-60" data-testid={testid}>{busy ? "Saving…" : label}</button>
);

export const lines = (s) => s.split("\n").map((x) => x.trim()).filter(Boolean);
